import angular from 'angular';

export default angular
  .module('csm.ui.reports.reportFormat', [])

  /*******************************************************************************
   * Directive: reportFormat
   *
   * Creates a dropdown list of report types to choose from. The ngModel is being
   * used here as a passthrough for consistency with Angular's model binding.
   * Report types can be dynamically excluded from the list of options with the
   * exclude-options attribute placed on the element.
   *
   * @ngdoc     directive
   * @name      reportFormat
   * @memberof  csm.ui.reports.reportFormat
   * @restrict  element
   *
   * @attr  {string}   classNames
   *   Optional. Space separated list of one or more CSS classes that will be applied to
   *   the rendered select element.
   *
   * @attr  {string}   excludeOptions
   *   Optional. A comma separated list of values to be excluded from the dropdown list
   *   By default, all options are shown.
   *
   * @attr  {string}   ngModel
   *   Required. Model to hold the selected value.
   *
   *******************************************************************************/
  /* @ngInject */
  .directive('reportFormat', function ($compile) {
    return {
      scope: {
        classNames: '@',
        excludeOptions: '@',
        format: '=ngModel'
      },
      template:
        "<select ng-model='format' class='reportSelect form-control' ng-class='classNames' ng-options='o as o for o in options'>" +
        '</select>',
      link: function (scope, elem, attrs) {
        /*-----------------------------------------------------------*/
        /* The form-inline sets child content to width auto so the   */
        /* select will size to its content. The inline-block         */
        /* ensures the dimensions of this element contain the select */
        /*-----------------------------------------------------------*/
        elem.addClass('form-inline');
        elem.css('display', 'inline-block');

        /*------------------*/
        /* Dropdown options */
        /*------------------*/
        var mOptionPDF = 'PDF';
        var mOptionExcel = 'EXCEL';
        var mOptionHTML = 'HTML';

        /*------------------------------------------*/
        /* Rebuild the array of available options   */
        /* when the excludeOptions property changes */
        /*------------------------------------------*/
        scope.$watch('excludeOptions', function (val) {
          scope.options = [mOptionPDF, mOptionExcel, mOptionHTML];

          /* if no values to be excluded, exit */
          if (!val) return;

          var opts = val.split(',');
          for (var i = 0, len = opts.length; i < len; i++) {
            switch (opts[i].trim().toUpperCase()) {
              case mOptionPDF:
                updateOptions(mOptionPDF);
                break;
              case mOptionExcel:
                updateOptions(mOptionExcel);
                break;
              case mOptionHTML:
                updateOptions(mOptionHTML);
                break;
            }
          }
        });

        /*****************************************************************************
         * updateOptions */
        /**
         * Remove the item from the list of dropdown options
         *
         * @param  elem     Item to be removed
         *****************************************************************************/
        function updateOptions(elem) {
          var index = scope.options.indexOf(elem);
          scope.options.splice(index, 1);
        }
      }
    };
  }).name;
